var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07558 12.701L14.4966 16.4427M14.4872 6.12019L8.07558 9.86187M19.7425 4.70061C19.7425 6.25825 18.4797 7.52097 16.9221 7.52097C15.3645 7.52097 14.1017 6.25825 14.1017 4.70061C14.1017 3.14297 15.3645 1.88025 16.9221 1.88025C18.4797 1.88025 19.7425 3.14297 19.7425 4.70061ZM8.46103 11.2814C8.46103 12.8391 7.19831 14.1018 5.64067 14.1018C4.08303 14.1018 2.82031 12.8391 2.82031 11.2814C2.82031 9.72381 4.08303 8.46109 5.64067 8.46109C7.19831 8.46109 8.46103 9.72381 8.46103 11.2814ZM19.7425 17.8623C19.7425 19.4199 18.4797 20.6826 16.9221 20.6826C15.3645 20.6826 14.1017 19.4199 14.1017 17.8623C14.1017 16.3046 15.3645 15.0419 16.9221 15.0419C18.4797 15.0419 19.7425 16.3046 19.7425 17.8623Z",
    stroke: "white",
    strokeWidth: 1.88024,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.37f5927b1a622f6c4fb4d4cc00b41a68.svg";
export { ForwardRef as ReactComponent };